/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react'
import { getRecommendations } from '../api'
import './SimilarBrandsModal.css'

const PRICE_LABELS = { '1': '$', '2': '$$', '3': '$$$', '4': '$$$$' }

function SimilarBrandsModal({ brand, onClose }) {
    const [similar, setSimilar] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        getRecommendations([brand.id], [], false, '').then(recs => {
            setSimilar((recs || []).slice(0, 5))
            setLoading(false)
        })
    }, [brand.id])

    const handleBackdrop = (e) => {
        if (e.target === e.currentTarget) onClose()
    }

    return (
        <div className="similar-modal-backdrop" onClick={handleBackdrop}>
            <div className="similar-modal">
                <div className="similar-modal-header">
                    <h3>Brands similar to {brand.name}</h3>
                    <button className="similar-modal-close" onClick={onClose}>×</button>
                </div>

                <div className="similar-modal-body">
                    {loading ? (
                        <div className="similar-loading">Finding matches...</div>
                    ) : similar.length === 0 ? (
                        <div className="similar-loading">No matches found.</div>
                    ) : (
                        <div className="similar-list">
                            {similar.map(({ brand: b }) => (
                                <div key={b.id} className="similar-item">
                                    <div className="similar-item-info">
                                        <div className="similar-item-name">
                                            {b.name}
                                            {PRICE_LABELS[b.price_range] && (
                                                <span className="similar-item-price">{PRICE_LABELS[b.price_range]}</span>
                                            )}
                                        </div>
                                        {b.description && (
                                            <p className="similar-item-desc">{b.description}</p>
                                        )}
                                    </div>
                                    {b.website_url && (
                                        <a
                                            href={b.website_url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="similar-item-visit"
                                        >
                                            Visit
                                        </a>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default SimilarBrandsModal
